import { AccordionComponent, SelectWithSearch } from "components";
import React, { useState } from "react";
import styled from "styled-components";
import { FormGroup, FormRow } from "styles/forms/main";
import { useMapDataToUiWithFilter } from "hooks/mapDataToOptions";
import EditHandler from "./EditHandler";

const WarningMessage = styled.p`
    font-size: 14px;
    font-weight: 400;
    background-color: #fbebe7;
    color: #410f03;
    border-radius: 10px;
    padding: 10px 25px;
    margin-top: auto;
`;
function TruckOwner({ driverData, handleDataFroSubmit, isEditable, errors, isEidtSection }) {
    const {
        data: allTrucks,
        setSearchFilter: setAllTrucksFilter,
        clearSearchFilter: clearAllTrucksFilter,
        isValuesReturned: isTrucksValuesReturned,
    } = useMapDataToUiWithFilter("trucks");
    const [isOnEdit, setIsOnEdit] = useState(false);

    return (
        <div>
            {driverData?.isTruckOwner && (
                <AccordionComponent
                    title="Trucks"
                    defaultExpanded
                    extraAction={
                        isEidtSection && (
                            <EditHandler
                                isOnEdit={isOnEdit}
                                setIsOnEdit={setIsOnEdit}
                            />
                        )
                    }
                    body={
                        <FormRow>
                            {driverData?.isTruckOwner && (
                                <FormGroup>
                                    <SelectWithSearch
                                        name="ownerPlateNumber"
                                        label="Plate Number"
                                        placeholder="Select"
                                        required
                                        options={allTrucks}
                                        isEditable={isEditable || isOnEdit}
                                        errorMessage={errors?.ownerPlateNumber}
                                        handleFilter={(filter) => {
                                            setAllTrucksFilter(filter);
                                            return allTrucks;
                                        }}
                                        onMenuClose={() => clearAllTrucksFilter()}
                                        value={driverData?.ownerPlateNumber}
                                        handleChange={(value) =>
                                            handleDataFroSubmit(value, "ownerPlateNumber")
                                        }
                                    />
                                </FormGroup>
                            )}
                            {!isTrucksValuesReturned && (
                                <FormGroup>
                                    <WarningMessage>
                                        Truck is not found please create it
                                    </WarningMessage>
                                </FormGroup>
                            )}
                        </FormRow>
                    }
                />
            )}
        </div>
    );
}

export default TruckOwner;
